import Icon from "@ant-design/icons";
import { Button } from "antd";
import React from "react";

export const DiscordButton: React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ children, ...props }) => (
  <Button
    {...props}
    size="large"
    type="primary"
    icon={
      <Icon
        component={() => (
          <img src="/discord_logo.svg" alt="discord" width="16" />
        )}
      />
    }
  >
    <span style={{ padding: "0 1rem" }}>{children}</span>
  </Button>
);
